/**
 * Carga el HTML procedente del server
 * @param {string} url Url donde obtener el HTML
 * @param {number} count Número de elementos a cargar.
 * @returns {Promise<string>}
 */
const fetchContent = (url, count) => {
    const target = `${url}?count=${count}`

    return fetch(target, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(response => response.text());
}

/**
 * Crea el observador que detonará el proceso de carga cuando haya intersección con Viewport
 * @param {Element} holder Generalmente el section-tag
 * @param {string} url Url a la que hacer la petición
 */

const createIntersectionObserver = (holder, url, count) => {
    try{
        const intersectionOptions = {
            rootMargin: '200px'
        }

        const intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadContent(holder, url, count);
                    intersectionObserver.unobserve(entry.target);
                }
            });
        }, intersectionOptions);

        intersectionObserver.observe(holder);

    }catch (e) {
        //Si no estuviese disponible (IE 11), carga al momento.
        loadContent(holder, url, count);
    }
}

/**
 * Crea el observador que detonará el proceso de carga.
 * @param {Element} holder Generalmente el section-tag
 * @param {string} url Url a la que hacer la petición
 * @param {number} count Número de elementos a obtener
 */
const loadContent = (holder, url, count) => {
    fetchContent(url, count)
        .then(html => holder.innerHTML = html)
        .then(() => app.tabs.init($(holder)))
        .catch(err => console.error(err));
}

/**
 * Comportamiento general de "Análisis más vistos" (o de "Últimas noticias premium").
 * Hace una consulta al servidor para obtener el HTML que se debe pintar.
 * Se le intenta aplicar IntersectionObserver si tiene data-scroll. Si falla o no tiene data-scroll, carga al instante
 */
export default function(){
    const holders = document.querySelectorAll('#most-viewed, #last-news-premium');
    holders.forEach(holder => {
        const itHasScrollTrigger = holder.dataset.scroll === "true";
        const url = unmaskpath(holder.dataset.url);
        const count = holder.dataset.count || 5;

        if (itHasScrollTrigger) {
            createIntersectionObserver(holder, url, count);
        } else {
            loadContent(holder, url, count);
        }
    });
}
